import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';
import { HUB_URL } from '../post-signup-onboarding-constants';

interface ResultHubStepProps {
	onComplete: () => void;
}

/** Step 4 (non-lt50k path): Complete setup on Hub – explanation, link, Continue to create org. */
export function ResultHubStep({ onComplete }: ResultHubStepProps) {
	const { t } = useTranslation('onboarding');
	return (
		<div className="space-y-6">
			<div className="space-y-2">
				<h2 className="text-foreground text-2xl font-bold tracking-tight">
					{t('resultHub.title')}
				</h2>
			</div>

			<div className="mx-auto max-w-lg rounded-xl border border-emerald-200 bg-emerald-50 p-5 text-left dark:border-emerald-900 dark:bg-emerald-950/20">
				<p className="text-sm leading-relaxed text-emerald-800 dark:text-emerald-200">
					{t('resultHub.description')}
				</p>
			</div>

			<a
				href={HUB_URL}
				target="_blank"
				rel="noopener noreferrer"
				className="inline-flex items-center gap-2 rounded-lg border border-emerald-600 px-4 py-2.5 text-sm font-medium text-emerald-600 transition-colors hover:bg-emerald-50 dark:border-emerald-400 dark:text-emerald-400 dark:hover:bg-emerald-900/20"
			>
				{t('resultHub.openHub')}
				<ExternalLink className="h-4 w-4" />
			</a>

			<div>
				<Button onClick={onComplete} size="lg" className="w-full max-w-md">
					{t('resultHub.continue')}
				</Button>
			</div>
		</div>
	);
}
